import { render, staticRenderFns } from "./connections.vue?vue&type=template&id=819507f0&"
import script from "./connections.vue?vue&type=script&lang=js&"
export * from "./connections.vue?vue&type=script&lang=js&"
import style0 from "./connections.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports